<template>
  <div class="box is-shadowless is-borderless has-background-secondary m-t-10 m-b-40">
    <div class="columns is-vcentered">
      <div class="column" :class="hideEdit ? 'is-12' : 'is-10'">
        <slot name="body"></slot>
      </div>
      <div v-if="!hideEdit" class="column is-2">
        <slot name="edit">
          <div
            class="has-text-centered has-text-weight-semibold is-size-4"
            @click="edit"
            :data-e2e="GuidanceStepCypressAttribute.modal.buttons.EDIT_FLOW_DETAIL_CARD"
          >
            <div class="is-hidden-mobile has-text-primary is-clickable">{{ $t('asset.edit') }}</div>
          </div>
        </slot>
      </div>
    </div>
    <div v-if="$slots.footer">
      <hr class="has-background-grey-light" />
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { GuidanceStepCypressAttribute } from '/@/modules/guidancestep/constants/GuidanceStepCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FlowDetailCard',
  emits: ['edit'],
  slotsDefinition: {
    body: {},
    edit: {},
    footer: {}
  },
  props: {
    hideEdit: {
      type: Boolean,
      default: false
    }
  },
  static: {
    GuidanceStepCypressAttribute
  },
  methods: {
    edit() {
      this.$emit('edit');
    }
  }
};
</script>
